import { useState } from 'react';

import { ICompanySettings } from 'auth/types';
import { IQuoteVersionData } from 'quotes/types';
import { Color } from 'theme/enums';

import { ChangeFreight } from './ChangeFreight';
import { FreightValue } from './FreightValue';

interface IProps {
  quoteVersionData: IQuoteVersionData;
  freightSettings?: Pick<ICompanySettings, 'defaultFreightPercentage' | 'minimumFreightCharge'>;
  partsTotal: number;
  classNames?: string;
  isEditable?: boolean;
}

export const TotalFreight = ({
  quoteVersionData,
  freightSettings = {},
  partsTotal,
  classNames = '',
  isEditable = false,
}: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  return (
    <>
      <FreightValue
        quoteVersionData={quoteVersionData}
        freightSettings={freightSettings}
        classNames={classNames}
        valueProps={isEditable ? { color: Color.PRIMARY, onClick: () => setIsEditOpen(true) } : {}}
      />

      {isEditable && (
        <ChangeFreight
          key={JSON.stringify(quoteVersionData)}
          quoteVersionData={quoteVersionData}
          partsTotal={partsTotal}
          freightSettings={freightSettings}
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
        />
      )}
    </>
  );
};
